export default "__VITE_ASSET__BsobWoyY__"